<template>
	<div>
		<myheader :backFlag="true" headTitle="上传签名图片"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card">
					<div class="text12 textcolor999 font_weight_bold">上传签名照片</div>
					<div class="text14 textcolor333 margin_top_5">支持jpg、jpeg、png格式，像素100*40或150*60，图片不超过1.5M</div>
					<div v-if="harmony" style="margin: .5rem auto .2rem;text-align: center; width: 80%;border:1px solid #ddd;border-radius: .3rem;padding: .5rem 0;">
						<van-uploader accept="image/*" v-model="imageFiles" :before-read="beforeRead"
							:after-read="afterRead" preview-size="7rem" :preview-full-image="false">
							<img v-show="imageFiles.length==0" style="width: 7rem; height: 7rem; "
								src="@/assets/images/fang_gallery.svg">
						</van-uploader>
					</div>
					<div v-else style="margin: .5rem auto .2rem;text-align: center; width: 80%;border:1px solid #ddd;border-radius: .3rem;padding: .5rem 0;"
						@click="selectStyle()">
						<img style="width: 7rem; height: 7rem; " :src="imgSrc">
					</div>
					<div class="text14 textcolor333" style="margin: 0 auto;text-align: center;">点击拍照/上传</div>
				</div>
			</div>
			<div class="all_tips_bottom_card">
				<button class="all_button24 width_100 text16" @click="jump()">完成</button>
			</div>
		</div>
		<van-popup v-model:show="showBottom" :overlay="false" position="bottom">
			<div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative" @click="takePhoto()">拍照
				</div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative" @click="selectImage()">相册
				</div>
				<div class="horizontal_line"></div>
				<div style="height:.5rem;background-color: #ededed;"></div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext all_height_line24 text14 textcolor999" @click="showBottom = false">
					取&nbsp;&nbsp;消</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		Uploader,
	} from 'vant';
	import {
		compressImage,
		harmonyTakePhoto,
		harmonySelectImage,
		isHarmony
	} from '../../../utils/nativeOtherOperate.js'
	export default {
		components: {
			[Uploader.name]: Uploader,
		},
		data() {
			return {
				//弹窗显示
				showBottom: false,
				//签名图片
				imgSrc: require('@/assets/images/fang_gallery.svg'),
				imageFiles: [],
				harmony:isHarmony(),
				//102400
				imageLimitSize: 102400,
			}
		},
		methods: {
			//提交后返回
			jump() {
				if(!this.imgSrc){
					this.$Toast('请上传签名图片！')
					return
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/my/api/saveSignature', {
					signature: this.imgSrc,
					isGenerate: false
				}, 'form').then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$Toast('保存成功！')
						this.$router.go(-1);
					} else {
						this.$Toast(res.message || '保存失败，请重试！')
					}
				});
			},
			beforeRead(file) {
				if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/jpg') {
					this.$Toast('请选择图片文件');
					return false;
				}
				return true
			},
			afterRead(file) {
				//todo压缩，然后修改背景
				// file.status = 'uploading';
				// file.message = '上传中...';
				if (file.file.size > this.imageLimitSize) {
					this.$store.dispatch(this.$LoadShow, true)
					this.Tool.compressImage(file, this.imageLimitSize, false).then((res) => {
						this.imgSrc = res
						//console.log('sucess', file, res)
						this.$store.dispatch(this.$LoadShow, false)
					}).catch(err => {
						file.status = 'failed';
						file.message = '压缩失败，请删掉重试';
						//console.log('err', file)
						this.$store.dispatch(this.$LoadShow, false)
						//console.log('该图片不支持压缩', err)
					})
				} else {
					this.imgSrc = file.content
				}
			},
			//拍照
			takePhoto() {
				this.showBottom = false
				if (isHarmony()) {
					// harmonyTakePhoto().then(res => {
					// 	console.log(res)
					// })
				} else {
					if (!window.plus) {
						return
					}
					var that = this
					var cmr = plus.camera.getCamera();
					cmr.captureImage(function(p) {
						console.log('成功：' + p)
						plus.io.resolveLocalFileSystemURL(p, function(entry) {
							console.log('entry-=', entry, entry.toLocalURL())
							that.imgSrc = 'data:image/png;base64,' + compressImage(entry
								.toLocalURL().replace('file://', ''))
						}, function(e) {
							that.$Toast('读取拍照文件错误!');
						});
					}, function(e) {
						that.$Toast('拍照失败!')
					}, {
						filename: '_doc/camera/',
						index: 1
					});
				}
			},
			//相册
			selectImage() {
				this.showBottom = false
				if (isHarmony()) {

				} else {
					if (!window.plus) {
						return
					}
					var that = this
					plus.gallery.pick(function(path) {
						console.log('gallery---=', path);
						if (path) {
							that.imgSrc = 'data:image/png;base64,' + compressImage(path.replace(
								'file://', ''))
						}
						//console.log(that.imgSrc)
					}, function(e) {}, {
						filter: "image"
					});
				}
			},
			//取消
			selectStyle() {
				this.showBottom = true
			},
			//初始化
			init() {}
		},
		mounted() {
			this.init()
		},
		beforeDestroy() {},
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";
</style>